import { render, staticRenderFns } from "./EbrightEditor.vue?vue&type=template&id=b985cc12"
import script from "./EbrightEditor.vue?vue&type=script&lang=js"
export * from "./EbrightEditor.vue?vue&type=script&lang=js"
import style0 from "./EbrightEditor.vue?vue&type=style&index=0&id=b985cc12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports